(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.directive('syncsettingsTable', [SyncSettingsTableDirectiveFn]);

    /* syncsettingsTable directive */
    function SyncSettingsTableDirectiveFn() {

        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/administration/modules/syncsettings/templates/syncsettings-table.template.html',
            controller: 'SyncSettingsTableController',
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

    }

})();